import styled from "styled-components";

export const UiModalTitle = styled.div`
	display: flex;
	align-items: center;
	column-gap: 6px;
	color: #1890ff;
`;

export const StyledDeprecateQuestion = styled.div`
	.ant-checkbox-group {
		display: flex;
		flex-direction: column;
		row-gap: 8px;
		width: 100%;
	}

	.ant-checkbox-wrapper {
		display: flex;
		align-items: center;
		column-gap: 8px;
		margin: 0;
		padding: 12px 16px;
		border: 1px solid #e4e7ec;
		border-radius: 2px;
		color: #333;
	}
`;
